import { isIterable } from "@thi.ng/checks";
import { iterator } from "../iterator";
import { partitionBy } from "./partition-by";
export function partitionTime(period, src) {
    return isIterable(src)
        ? iterator(partitionTime(period), src)
        : partitionBy(() => {
            let last = 0;
            return () => {
                const t = Date.now();
                t - last >= period && (last = t);
                return last;
            };
        }, true);
}
